export default class Line {
  constructor(view) {
    this.view = view;
    this.view.visible = false;
  }

  setVisible(visible) {
    this.view.set({ visible, alpha: 1 });
  }

  showWin() {
    this.view.set({ visible: true, alpha: 0 });
    createjs.Tween.get(this.view, { loop: true })
      .to({ alpha: 1 }, 700)
      .to({ alpha: 0 }, 700);
  }

  hide() {
    createjs.Tween.removeTweens(this.view);
    this.view.set({ visible: false });
  }
}



// WEBPACK FOOTER //
// ../base/js/display/Line.js